// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767px) {
    .dimono-main{
        background-color: white!important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/brands/pages/DimonoPage.css"],"names":[],"mappings":"AAAA;IACI;QACI,iCAAiC;IACrC;AACJ","sourcesContent":["@media (max-width: 767px) {\n    .dimono-main{\n        background-color: white!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
